import React from 'react'

export default function Logout({ className }) {
  return (
    <svg viewBox="0 0 16 16" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M14.524 15.07H5.81a.847.847 0 01-.834-.859v-2.137c0-.474.374-.859.834-.859.461 0 .835.385.835.859v1.278h7.044V2.664H6.645v1.173a.848.848 0 01-.835.859.847.847 0 01-.834-.859V1.805c0-.474.374-.859.834-.859h8.714c.461 0 .834.385.834.859v12.406a.847.847 0 01-.834.859zM6.779 5.403l1.18-1.214 3.12 3.211.001.001.589.607-.589.607-.001.001-3.12 3.212-1.18-1.215 1.696-1.746H1.471a.847.847 0 01-.834-.859c0-.474.373-.859.834-.859h7.004L6.779 5.403z"
      />
    </svg>
  )
}
